var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005320"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 70",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#2075BC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 72",
    cx: 3,
    cy: 10,
    r: 3,
    fill: "#2075BC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 71",
    cx: 11,
    cy: 3,
    r: 3,
    fill: "#2075BC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73",
    cx: 11,
    cy: 10,
    r: 3,
    fill: "#2075BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.58e53cdb650bb50966f3c61ad14cd9c9.svg";
export { ForwardRef as ReactComponent };